module.exports = __webpack_public_path__ + "img/icon_exchange_module1.598b043f.png";